var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartner3Backdrop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 472,
    height: 358,
    viewBox: "0 0 472 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_631_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.245 357H104.245V289H220.245V357ZM96 346H-20V298H96V346ZM482 70H366V14H482V70ZM364 53H186V9H364V53ZM133.914 43H10.9141V0H133.914V43Z",
    fill: "url(#paint0_linear_631_67)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_631_67",
    x: -220,
    y: -200,
    width: 902,
    height: 757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_631_67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_67",
    x1: 235.5,
    y1: -4.66387e-7,
    x2: 235.5,
    y2: 357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFFEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8088FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner3Backdrop);
export default __webpack_public_path__ + "static/media/partner_3_backdrop.5a20549cdba9ae41c4d06a6f34751eb0.svg";
export { ForwardRef as ReactComponent };